import { render, staticRenderFns } from "./OrderListExchangeDeliveryNew.vue?vue&type=template&id=1a080a66&scoped=true"
import script from "./OrderListExchangeDeliveryNew.vue?vue&type=script&lang=js"
export * from "./OrderListExchangeDeliveryNew.vue?vue&type=script&lang=js"
import style0 from "./OrderListExchangeDeliveryNew.vue?vue&type=style&index=0&id=1a080a66&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a080a66",
  null
  
)

export default component.exports